import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e4f5e52a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "opModal carolAnnouncementModal" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "body" }
const _hoisted_4 = {
  key: 0,
  class: "carolAnnouncementContent"
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<p data-v-e4f5e52a>Dear User,</p><p data-v-e4f5e52a>We are writing to inform you about a change concerning the Welfood platform and the management of your personal data.</p><p data-v-e4f5e52a>As you may have read, <strong data-v-e4f5e52a>Welfood has become part of Carol</strong>, a digital healthcare platform focused on people&#39;s wellbeing. This change is part of a broader project to integrate 360° wellbeing services with health and prevention services, providing you with a more complete and integrated experience.</p><p data-v-e4f5e52a>In practical terms, nothing will change for you in how you use the platform: the service will continue to operate as before, with the same attention to privacy and the same security guarantees you are accustomed to.</p><p data-v-e4f5e52a>What changes is the legal entity acting as the <strong data-v-e4f5e52a>Data Controller</strong> of your personal data: this role transfers from Welfood S.r.l. to <strong data-v-e4f5e52a>Carol S.r.l.</strong> As required by data protection law (EU Regulation 2016/679 – GDPR), the updated privacy information under Article 14 of the GDPR is provided alongside this message and describes in detail how your data is processed and what your rights are.</p><p data-v-e4f5e52a>If you have any questions or wish to exercise your privacy rights, you can contact us at <a href=\"mailto:privacy@carol.health\" data-v-e4f5e52a>privacy@carol.health</a> or the Data Protection Officer of Carol at <a href=\"mailto:dpo@carol.health\" data-v-e4f5e52a>dpo@carol.health</a>.</p><p data-v-e4f5e52a>We are pleased to continue this journey with you and remain committed to your wellbeing.</p><p data-v-e4f5e52a>Sincerely,<br data-v-e4f5e52a><strong data-v-e4f5e52a>The Welfood Team – part of Carol</strong></p>", 8)
const _hoisted_13 = [
  _hoisted_5
]
const _hoisted_14 = {
  key: 1,
  class: "carolAnnouncementContent"
}
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<p data-v-e4f5e52a>Gentile Utente,</p><p data-v-e4f5e52a>ti scriviamo per comunicarti un cambiamento che riguarda la piattaforma Welfood e la gestione dei tuoi dati personali.</p><p data-v-e4f5e52a>Come forse avrai letto, <strong data-v-e4f5e52a>Welfood è entrata a far parte di Carol</strong>, piattaforma di servizi sanitari digitali per il benessere delle persone. Questo passaggio si inserisce in un progetto più ampio che punta a integrare i servizi di benessere 360° con quelli di salute e prevenzione, offrendoti un&#39;esperienza sempre più completa e integrata.</p><p data-v-e4f5e52a>In termini pratici, per te non cambia nulla nell&#39;utilizzo della piattaforma: il servizio continuerà a funzionare come sempre, con le stesse modalità, la stessa attenzione alla riservatezza e le stesse garanzie di sicurezza a cui sei abituato/a.</p><p data-v-e4f5e52a>Ciò che cambia è il soggetto che, dal punto di vista legale, è <strong data-v-e4f5e52a>Titolare del trattamento dei tuoi dati personali</strong>: questo ruolo passa da Welfood Sr.l. a <strong data-v-e4f5e52a>Carol S.r.l.</strong> Come previsto dalla normativa sulla protezione dei dati personali (Regolamento UE 2016/679 – GDPR), trovi in allegato l&#39;informativa aggiornata ai sensi dell&#39;art. 14 del GDPR, che descrive nel dettaglio come i tuoi dati sono trattati e quali sono i tuoi diritti.</p><p data-v-e4f5e52a>Se hai domande o vuoi esercitare i tuoi diritti in materia di privacy, puoi contattarci in qualsiasi momento scrivendo a <a href=\"mailto:privacy@carol.health\" data-v-e4f5e52a>privacy@carol.health</a> oppure al Responsabile della Protezione dei Dati di Carol all&#39;indirizzo <a href=\"mailto:dpo@carol.health\" data-v-e4f5e52a>dpo@carol.health</a>.</p><p data-v-e4f5e52a>Siamo felici di poter continuare questo percorso insieme a te, con l&#39;impegno di sempre verso il tuo benessere.</p><p data-v-e4f5e52a>A presto,<br data-v-e4f5e52a><strong data-v-e4f5e52a>Il Team Welfood – parte di Carol</strong></p>", 8)
const _hoisted_23 = [
  _hoisted_15
]
const _hoisted_24 = { class: "mt-4 text-center" }

import { computed } from 'vue';
import { CommonServices } from '@/services/CommonServices';
import { StorageServices } from '@/services/StorageServices';
import { baseUrl } from '@/config';
import store from '@/store';


export default /*#__PURE__*/_defineComponent({
  props: {
    userIdentifier: null,
    language: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({ (e: 'close'): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { userIdentifier: string; language: string }




const isEnglish = computed(() => props.language === 'en-US');

async function dismiss() {
    try {
        const consent = await CommonServices.defaultPost<any>(baseUrl + 'api/AppUser/AcceptCarolConsent', {}, {}, true);
        // Update the store with the consent returned by the backend
        if (store.state.user && consent) {
            store.state.user.carolDataControllerConsent = consent;
            // Also persist to localStorage so on page refresh the consent is not lost
            StorageServices.setLoggedUser(store.state.user);
        }
    } catch (error) {
        console.error('Failed to save Carol consent:', error);
    } finally {
        emit('close');
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_unref(isEnglish) ? 'Important update' : 'Aggiornamento importante'), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_unref(isEnglish))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_13))
        : (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_23)),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-block noShadow btn-primary",
          onClick: dismiss
        }, _toDisplayString(_unref(isEnglish) ? 'I understand' : 'Ho capito'), 1)
      ])
    ])
  ]))
}
}

})